import {Component, OnInit, Input, ChangeDetectorRef, HostListener, OnDestroy, OnChanges, SimpleChanges} from '@angular/core';
import { Subject } from 'rxjs';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { takeUntil } from 'rxjs/operators';
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT } from 'src/app/app.models';
import { InputGridModel } from '../input-grid.model';
import { DynamicFormControlModel, DynamicFormArrayModel } from '@ng-dynamic-forms/core';
import { COMPONENT_MODE } from '../../workflow-components.models';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'abw-input-grid-design',
    templateUrl: './input-grid-design.component.html',
    styleUrls: ['./input-grid-design.component.scss']
})
export class InputGridDesignComponent implements OnInit, OnDestroy {
    isComponentSelected = false;
	@Input() model: InputGridModel;
    @Input() value: any;
    onComplete = new Subject();

    totalRows = 1;
    rowsFormsGroup: FormGroup[] = [];
    rowsFormsModel: DynamicFormControlModel[][] = [];

    constructor(
        private _workflowComponentsService: WorkflowComponentsService,
        private _cdf: ChangeDetectorRef,
    ) {
    }

    async ngOnInit() {
        this._workflowComponentsService.workflowDesignerComponentSelected$.pipe(takeUntil(this.onComplete)).subscribe(_selectedComponent => {
            this.isComponentSelected = _selectedComponent != null && _selectedComponent.GUID == this.model.additional.GUID;
            this._cdf.detectChanges();
        });
        await this._buildGridForm();
    }

    @HostListener("click") onClick(){
        const base_component = this.model.additional as Model_WorkflowComponent;
        base_component.PROPERTIES = this.value;
        this._workflowComponentsService.workflowDesignerComponentSelected$.next(base_component);
    }

    ngOnDestroy() {
        this.onComplete.next();
        this.onComplete.complete();
    }

    private async _buildGridForm() {
        const rowsFormsModel = [];
        const rowsFormsGroup = [];
        for (var i = 0; i < this.totalRows; i++) {
            const rowFormModel = await this._workflowComponentsService.doBuildWorkflowModel(this.model.gridColumns, { COMPONENTS_MODE: COMPONENT_MODE.DESIGN });
            const rowFormGroup = await this._workflowComponentsService.doBuildWorkflowFormGroup(rowFormModel);
            rowsFormsModel.push(rowFormModel);
            rowsFormsGroup.push(rowFormGroup);
        }
        this.rowsFormsModel = rowsFormsModel;
        this.rowsFormsGroup = rowsFormsGroup;
        try { this._cdf.detectChanges(); } catch(e) {}
    }
}